import React from 'react';
import { ratingStrings } from '../../content/ratings';

/** Displays a saved five-star rating without the editor's interactive controls. */
export default function RatingReadout({ rating }) {
  const value = Number(rating);
  if (!Number.isFinite(value) || value <= 0) return null;

  return (
    <span className="rating-readout" aria-label={ratingStrings.value(value)}>
      <span className="rating-readout-stars" aria-hidden="true">
        {Array.from({ length: 5 }, (_, index) => {
          const remaining = Math.max(0, Math.min(1, value - index));
          return (
            <span className="rating-readout-star" key={index}>
              <span className="rating-readout-star-base">☆</span>
              <span className="rating-readout-star-fill" style={{ width: `${remaining * 100}%` }}>★</span>
            </span>
          );
        })}
      </span>
      <span className="rating-readout-value">{value.toFixed(1)}</span>
    </span>
  );
}
